import { render, staticRenderFns } from "./PortTable.vue?vue&type=template&id=066a049a&"
import script from "./PortTable.vue?vue&type=script&lang=ts&"
export * from "./PortTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports